import React from "react";
import PropTypes from "prop-types";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";
import styles from "components/documents/trash-document-modal.scss";
import { focusedDocumentType } from "custom-prop-types";

export const TrashDocumentModal = ({
  accountId,
  focusedDocument,
  isTrashDocumentVisible,
  onHideTrashDocument,
  onTrashDocument
}) => (
  <Modal
    isVisible={ isTrashDocumentVisible }
    onClose={ onHideTrashDocument }
    transitionName={ "trash-document" }
  >
    <div>
      <h3>Send document to trash?</h3>
      <div className={ styles.buttons }>
        <Button link onClick={ onHideTrashDocument }>cancel</Button>
        <Button danger onClick={ () => { onTrashDocument(accountId, focusedDocument); onHideTrashDocument(); } }>
          Trash
        </Button>
      </div>
    </div>
  </Modal>
);

TrashDocumentModal.defaultProps = {
  focusedDocument: null
};

TrashDocumentModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  focusedDocument: focusedDocumentType,
  isTrashDocumentVisible: PropTypes.bool.isRequired,
  onHideTrashDocument: PropTypes.func.isRequired,
  onTrashDocument: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/trash-document-modal.jsx